import state from '@/store/modules/menu/state'
import actions from '@/store/modules/menu/actions'
import mutations from '@/store/modules/menu/mutations'
import getters from '@/store/modules/menu/getters'

export default {
  state,
  actions,
  mutations,
  getters
}
